
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restake",
      function () {
        return require("private-next-pages/restake.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restake"])
      });
    }
  